@if ($product(); as product) {
  <div class="image">
    <boels-media sizes="256px" [container]="$image()" [alt]="product.name">
    </boels-media>
    @if ($ecoLabel()?.hasLabel) {
      <boels-product-eco
        [tooltipText]="$ecoLabel()!.value"
        tooltipPlacement="above"
      ></boels-product-eco>
    }
  </div>

  <boels-product-identifier
    [product]="product"
    [displayCodeDescription]="false"
  ></boels-product-identifier>

  <a
    [cmsRouterLink]="product.url"
    target="{{ $openInNewTab() ? '_blank' : '_self' }}"
    class="name"
  >
    <div
      class="name-text"
      [innerHTML]="
        product.variantOptions ? product.baseProductName : product.name
      "
    ></div>
    <fa-icon [icon]="faArrowRight"></fa-icon>
  </a>
  @if ($isPlatformBrowser()) {
    <boels-product-price [product]="product"></boels-product-price>
  } @else {
    <boels-skeleton
      [inputHeight]="48"
      [inputStyle]="{ borderRadius: '4px' }"
      [runOnServer]="true"
    ></boels-skeleton>
  }
  <boels-product-in-cart-label
    [$product]="product"
    [$orderEntry]="$orderEntry()"
  ></boels-product-in-cart-label>
  <div class="link">
    <boels-add-to-cart-button
      [$product]="product"
      [$orderEntry]="$orderEntry()"
      [$buttonConfig]="{
        variant: 'secondary',
      }"
    ></boels-add-to-cart-button>
  </div>
}
